import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function getContractCenterData(id) {
  const query = `query ContractCenter(
    $id: ID
  ) {
    ContractCenter(id: $id) {

      contractData{ 
        rfq {
          rfr
          hits
          drafts
          submitted
          awarded
          requested
          archived
        }
        quotes {  
          drafts
          hits
          submitted
          awarded
          requested
          archived
        }
        dibbs {
          drafts
          hits
          submitted
          awarded
          requested
          archived
          created
          warning
          
        }
      }
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.ContractCenter.contractData;
}

// export async function createRFQ(userId) {
//   const query = `mutation createRFQ($userId: ID, $solNum: String, $participants: [String]) { createRFQ (userId: $userId, solNum: $solNum, participants: $participants) { status msg rfqId  } }`;

//   // Variables
//   const variables = { userId };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

export async function archiveQuote(userId, rfqId, quoteId) {
  const query = `mutation archiveQuote($rfqId: Int, $userId: ID, $quoteId: Int,) { archiveQuote (rfqId: $rfqId, userId: $userId, quoteId: $quoteId) { status   } }`;

  const variables = { userId, rfqId, quoteId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function archiveRFQ(userId, rfqId) {
  const query = `mutation archiveRFQ($rfqId: Int, $userId: ID, ) { archiveRFQ (rfqId: $rfqId, userId: $userId, ) { status   } }`;

  const variables = { userId, rfqId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/graphql.js